import { defineMessages } from 'react-intl';

export default defineMessages({
    periodStartDateTooltipContent: {
        id: 'ml.quoteandbind.landingPage.periodStartDate.tooltipContent.paragraph1',
        defaultMessage: 'The date shown is the effective date from your saved quote. Hit Continue if you wish to proceed using this date.',
    },
    periodStartDateTooltipContentParagraph2: {
        id: 'ml.quoteandbind.landingPage.periodStartDate.tooltipContent.paragraph2',
        defaultMessage: 'For a new effective date, update the date fields to be at least one day in the future and hit Continue to proceed with your quote.',
    }
});
